export enum OpportunityStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  CANCELLED = 'Cancelled',
  EXPIRED = 'EXPIRED'
}